import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function GoogleCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleGoogleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const errorParam = searchParams.get('error');

        if (errorParam) {
          throw new Error(errorParam === 'access_denied' ? 'Google authentication was cancelled' : `Google authentication error: ${errorParam}`);
        }

        if (!code) {
          throw new Error('No authorization code received from Google');
        }

        console.log('[GoogleCallback] Received auth code, exchanging for token...');

        // Decode state to get signup context (if it's a signup flow)
        let referralCode = null;
        if (state) {
          try {
            const decodedState = JSON.parse(atob(state));
            referralCode = decodedState.referralCode;
            console.log('[GoogleCallback] Decoded state, referralCode:', referralCode);
          } catch (e) {
            console.warn('[GoogleCallback] Could not decode state:', e.message);
          }
        }

        // Exchange code for token via backend
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/google/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code,
            referral_code: referralCode, // Pass referral code for signup flow
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Failed to authenticate with Google');
        }

        console.log('[GoogleCallback] Authentication successful');

        // Store token
        localStorage.setItem('token', data.token);

        // Redirect based on email
        if (data.email === 'mjoechia@gmail.com') {
          window.location.href = '/admin';
        } else {
          window.location.href = '/dashboard';
        }
      } catch (err) {
        console.error('[GoogleCallback] Error:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    handleGoogleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-margin-mobile">
      <div className="w-full max-w-md text-center">
        {loading ? (
          <>
            <div className="mb-4 flex justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>
            <h2 className="text-headline-md text-on-background mb-2">Signing you in...</h2>
            <p className="text-body-md text-on-background/60">Please wait while we complete your authentication.</p>
          </>
        ) : (
          <>
            <h2 className="text-headline-md text-error mb-4">Authentication Failed</h2>
            <div className="bg-error/10 border border-error text-error p-4 rounded-lg mb-6 text-body-sm">
              {error}
            </div>
            <button
              onClick={() => navigate('/login')}
              className="w-full bg-primary text-on-primary font-medium py-2 rounded-lg hover:opacity-90 transition-opacity text-body-md"
            >
              Back to Login
            </button>
            <button
              onClick={() => navigate('/signup')}
              className="w-full bg-surface border border-outline text-on-surface font-medium py-2 rounded-lg hover:bg-surface/80 transition-colors mt-3 text-body-md"
            >
              Back to Signup
            </button>
          </>
        )}
      </div>
    </div>
  );
}
